/**
 * @file 文档页页面路由
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import ContributionGuide from './ContributionGuide';

const DocRoute = () => {
    return (
        <BrowserRouter>
            <Switch>
                <Route path="/contributionguide" component={ContributionGuide} />
            </Switch>
        </BrowserRouter>
    );
};

export default DocRoute;